export default __webpack_public_path__ + "static/media/product-detail-full-05.35b0b6fe.jpg";